import { 
    Text,
    Grid,
    Container
} from "@nextui-org/react"
// import { Fade } from 'react-awesome-reveal'

import Button from "../../../ui/button"
import Header from "../../../ui/header"
import { Box } from "../../../ui/layout/box"
import { Content } from "../../../ui/layout/content"
import SectionImg from '../../../ui/resources/GL_section_img_1.png'
import SectionBkg from '../../../ui/resources/GL_section_bkg_1.png'
import Services from "../../services"

export default ({}) => {
    return (
        <>
            {/* <img 
                src={SectionBkg}
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "50%",
                    zIndex: -1,
                    transform: "scaleX(-1)"
                }} /> */}
            {/* <Fade
                cascade={true}
                triggerOnce={true}
                fraction={0.3}> */}
                <Content spacerSize={4} id="services">
                    <Grid.Container justify="center">
                        <Grid xs={12} sm={6} css={{flexDirection: "column"}}>
                            <Header value="For Businesses & Start-Ups" h1 centered />
                            <Text size="$sm" className="font-text" css={{mt: "$md", ta: "center"}}>We are an extended part of your team, leading the collaboration while you focus on building and scaling your business</Text>
                            {/* <Box css={{mt: "80px"}}>
                                <Button text="See What We Do for You"/>
                            </Box> */}
                        </Grid>
                        {/* <Grid xs={0} sm={6} css={{justifyContent: "center"}}>
                            <img src={SectionImg} width="300px" />
                        </Grid> */}
                    </Grid.Container>
                </Content>
                <Services/>
            {/* </Fade> */}
        </>
    )
}